import logo from './logo.svg'
import checkcircle from './checkcircle.svg'

export default { logo, checkcircle }



// WEBPACK FOOTER //
// ./src/config/assets/index.js